<template>
  <v-dialog v-model="dialog" scrollable max-width="300px">
    <template #activator="{ on, attrs }">
      <v-btn class="ma-1" v-bind="attrs" v-on="on" :disabled="sent">Report</v-btn>
    </template>
    <v-card>
      <v-card-title>Report reason</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 300px">
        <v-form ref="form">
          <v-radio-group v-model="value" column required>
            <v-radio label="Spam (offensive, unrelated, duplicate)" value="spam"></v-radio>
            <v-radio label="Low quality (memes, blurry pics)" value="quality"></v-radio>
            <v-radio label="Mislabelled (incorrect characters or artist)" value="label"></v-radio>
            <v-radio label="Other" value="other"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="value === 'other'"
            placeholder="Please explain"
            v-model="reason"
            :rules="[ v => !!v || 'You must specify a reason' ]"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="reset">Close</v-btn>
        <v-btn :disabled="sent" text @click="send">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '../plugins/axios'

export default {
  props: {
    image: String
  },
  data () {
    return {
      sent: false,
      value: '',
      reason: '',
      dialog: false,
    }
  },
  methods: {
    reset () {
      this.dialog = false
    },
    async send () {
      if (this.value !== 'other') {
        this.reason = this.value
      }

      if (this.$refs.form.validate()) {
        this.sent = true
        let formData = new FormData()
        formData.append('image', this.image)
        formData.append('reason', this.reason)

        try {
          await axios.post(`/report`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          this.dialog = false
        } catch (error) {
          this.sent = false
          alert('An error occured')
          return
        }
      }
    }
  },
  watch: {
    dialog (value) {
      if (!value) {
        this.value = ''
        this.reason = ''
      }
    }
  }
}
</script>
